import axios from "axios";
import config from "../../config";

const apiUrl = config.api;

export interface UnusedObjectFinding {
  databaseName: string;
  schemaName: string;
  objectName: string;
  objectType: string;
  createdDate: string;
  modifiedDate: string;
  lastObservedUsageDate: string;
  referencedObjectCount: number;
  referencingObjectCount: number;
  reason: string;
}

export interface DatabaseFindings {
  databaseName: string;
  findingCount: number;
  findings: UnusedObjectFinding[];
}

export interface UnusedObjectsResponse {
  results: DatabaseFindings[];
}

export const getUnusedSqlObjects = async (): Promise<UnusedObjectsResponse> => {
  const response = await axios.get<UnusedObjectsResponse>(
    `${apiUrl}/monitoring/sql/unused-objects`,
  );
  return response.data;
};
